import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import useDataFetch from "../../hooks/useDataFetch";
import RenderData from "./partials/renderData";
import RenderLoading from "./partials/renderLoading";
import RenderError from "./partials/renderError";
import {
  updateTitle,
  updateJobDesignation,
  updateExperience,
  resetStepOne,
  updateSkills,
  updateStatus,
} from "../../store/steps/stepOneSlice";
import { resetStepFour } from "../../store/steps/stepFourSlice";
import { resetStepFive } from "../../store/steps/stepFiveSlice";
import { apiService } from "./services/apiService";
import { resetStepTwo } from "../../store/steps/stepTwoSlice";

const Create = () => {
  const { assessmentId } = useParams();
  const { data, loading, error } = useDataFetch(apiService.getAssessmentById, {
    req: assessmentId,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      dispatch(updateTitle(data.name));
      dispatch(updateStatus(data.status));
      dispatch(updateJobDesignation(data.role));
      dispatch(
        updateExperience([
          data.yearsOfExperience.min,
          data.yearsOfExperience.max,
        ])
      );
      dispatch(updateSkills([...data.expertiseInSkills]));
    }
  }, [data, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetStepOne());
      dispatch(resetStepTwo());
      dispatch(resetStepFour());
      dispatch(resetStepFive());
    };
  }, []);

  if (error) {
    return <RenderError />;
  }

  if (loading) {
    return <RenderLoading />;
  }

  return <RenderData />;
};

export default Create;
